import { useUser } from '@ad-lucy/gateway-provider';
import { Button, Icon } from '@ad-lucy/ui';
import { useI18n } from '@i18n/i18n.utils';
import { useNavigate } from 'react-router-dom';
import { ErrorView } from '../ErrorView';
import type { IErrorView } from '../ErrorView/ErrorView.types';
import { LinkButton } from '../LinkButton';

export function DefaultActionsErrorView({
  secondaryAction,
  primaryAction,
  ...rest
}: Readonly<IErrorView>): JSX.Element {
  const { t } = useI18n();
  const navigate = useNavigate();
  const user = useUser();
  const goBack = () => navigate(-1);

  return (
    <ErrorView
      {...rest}
      secondaryAction={
        secondaryAction ?? (
          <Button
            onClick={goBack}
            startAdornment={<Icon size="sm" type="IconArrowLeft" />}
          >
            {t('errorView.general.goBack')}
          </Button>
        )
      }
      primaryAction={
        primaryAction ?? (
          <LinkButton
            to={user.require('quickstart:view') ? '/quickstart' : '/campaigns'}
            variant="primary"
          >
            {user.require('quickstart:view')
              ? t('navigation.quickstart')
              : t('navigation.campaigns')}
          </LinkButton>
        )
      }
    />
  );
}
